// The HTML comes from the authorized status request, rendered by the same Rails
// partial as the initial row. Validate before changing any authoritative node.
export function parseStatusFragment(item, payload) {
  if (typeof payload.fragment_html !== "string" || !payload.fragment_html.trim()) return null

  const parsed = new DOMParser().parseFromString(payload.fragment_html, "text/html")
  const fragments = parsed.querySelectorAll("[data-upload-fragment]")
  if (fragments.length !== 1) return null
  const fragment = fragments[0]
  if (fragment.dataset.uploadId !== item.dataset.uploadId ||
      fragment.dataset.uploadPurpose !== item.dataset.uploadPurpose ||
      fragment.dataset.uploadState !== payload.state) return null

  const time = fragment.querySelector("time[datetime]:not([data-upload-expires-at])")
  const message = fragment.querySelector("[data-upload-message]")
  if (time?.dateTime !== payload.last_updated_at || message?.textContent.trim() !== payload.message ||
      !fragment.querySelector("[data-upload-filename]") ||
      !fragment.querySelector("[data-upload-destination]") ||
      !fragment.querySelector("[data-upload-actions]") ||
      !item.querySelector("[data-upload-fragment]")) return null

  return fragment
}

export function applyStatusFragment(item, fragment) {
  const previous = item.querySelector("[data-upload-fragment]")
  const focused = document.activeElement
  const hadFocus = previous.contains(focused)
  const action = hadFocus ? focused?.dataset.uploadAction : null

  // Retain the live region itself so updates are announced by assistive tech.
  const message = item.querySelector("[data-upload-message]")
  const incomingMessage = fragment.querySelector("[data-upload-message]")
  message.replaceChildren(...incomingMessage.childNodes)
  incomingMessage.replaceWith(message)
  previous.replaceWith(fragment)
  item.dataset.uploadActionToken = fragment.dataset.uploadActionToken || ""

  if (hadFocus) {
    const replacement = Array.from(fragment.querySelectorAll("[data-upload-action]")).find(
      (button) => button.dataset.uploadAction === action
    )
    if (replacement) {
      replacement.focus({ preventScroll: true })
    } else {
      item.setAttribute("tabindex", "-1")
      item.focus({ preventScroll: true })
    }
  }
}
